import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import { db } from '@/main';


export const namespaced = true

export const state = {
	customers: [],
	customer: {},
	category: {
		id: '',
		name: '',
		order: 1,
		photo_name: '',
		photo_url: '',
		subtitle: '',
		visible: true
	},
	categories: [],
	loaded: false,
	dialog: false,
	dialogList: false,
	editMode: false,

}

export const mutations = {

	SET_LOADED(state, data) {
		state.loaded = data
	},
	SET_CATEGORY(state, data) {
		state.category = data
	},
	SET_CATEGORIES(state, data) {
		state.categories = data
	},
	SET_CATEGORY_DIALOG: (state, data) => {
		state.dialog = !state.dialog;
		state.editMode = data.editMode;
		state.category = data.category;
	},
	SET_DIALOG_LIST: (state, data) => {
		state.dialogList = data
	}
}

export const actions = {
	setDialogList({ commit }, data) {
		commit('SET_DIALOG_LIST', data);
	},
	toggleCategoryDialog({ commit }, data) {
		commit('SET_CATEGORY_DIALOG', data);
	},
	setLoaded({ commit }, data) {
		commit('SET_LOADED', data)
	},
	setCategory({ commit }, data) {
		commit('SET_CATEGORY', data)
	},
	getCategories({ commit, dispatch },business_id) {
		commit('SET_CATEGORIES', []);
		dispatch('setLoaded', false, { root: false })
		return new Promise(resolve => {
			let cats = []
			db.collection('bussiness').doc(business_id).collection('categories')
				.orderBy('order').onSnapshot(snap => {
					// if (snap.empty) {
					// 	console.log('Not matching documents.')
					// 	dispatch('setLoaded', true, { root: false })
					// 	return
					// }
					cats = []
					snap.forEach(doc => {
						cats.push({ id: doc.id, ...doc.data() })
					})

					commit('SET_CATEGORIES', cats);
					dispatch('setLoaded', true, { root: true })

				resolve();
			})
		});
	}
}

export const getters = {

	categoriesDialog: (state) => {
		return state.dialog;
	},
	categoryForEdit: (state) => {
		return state.category;
	},
	categoryDialogEditMode: (state) => {
		return state.editMode;
	},
	categoryLoaded: (state) => {
		return state.loaded;
	},
	categoriesList: (state) => {
		return state.categories;
	},
	dialogsList: (state) => {
		return state.dialogList;
	}

}
